import {SalesSearchParamType} from "../interface";
import React, {Dispatch, SetStateAction, useEffect, useMemo} from "react";
import {SubmitHandler, useForm} from "react-hook-form";
import moment from "moment/moment";
import {useReadTeamName} from "../hooks/useReadTeamName";
import {useReadHandlerName} from "../hooks/useReadHandlerName";
import {useUser} from "../../../../../util/userContext/UserContext";
import AuthorityChecker from "../../../../../components/common/authorityGuard/AuthorityChecker";

interface PropsType {
    searchParam: SalesSearchParamType
    setSearchParam: Dispatch<SetStateAction<SalesSearchParamType>>
    tab?: number
    pageType?: "company"
    isModify?: boolean
    btnModifySave?: () => any
    toggleIsModify?: () => any
}

export default function Filter({
                                   searchParam,
                                   setSearchParam,
                                   tab,
                                   pageType,
                                   isModify,
                                   btnModifySave,
                                   toggleIsModify
                               }: PropsType) {
    const {user} = useUser();

    const {register, handleSubmit, getValues, setValue, watch} = useForm({
        defaultValues: searchParam,
    });

    const teamList = useReadTeamName()?.data?.teamVOList
    const handlerList = useReadHandlerName({
        teamId: watch("teamId") ?? ""
    })?.data?.userVOList

    const onSubmit: SubmitHandler<SalesSearchParamType> = (submitData) => {
        setSearchParam({...submitData, pageNo: 1})
    };

    const yearOptions = useMemo(() => {
        const currentYear = moment().year();

        const list = []
        for (let i = currentYear; i >= 2023; i--) { // 1970
            list.push(<option value={i}>{i}</option>)
        }

        return list
    }, [])

    const monthOptions = useMemo(() => {
        const list = []

        list.push(<option value={0}>전체</option>)

        for (let i = 1; i <= 12; i++) {
            list.push(<option value={i}>{i}</option>)
        }

        return list
    }, [])

    useEffect(() => {
        if (tab) {
            if (tab === 1) {
                setValue("revenueMonth", 0)
                setSearchParam({...searchParam, revenueMonth: 0})
            } else {
                setValue("revenueMonth", moment().month() + 1)
                setSearchParam({...searchParam, revenueMonth: moment().month() + 1})
            }
        }
    }, [tab]);

    useEffect(() => {
        if (user && pageType !== "company") {
            setSearchParam({...searchParam, teamId: user.teamId, handlerId: user.userId})
            setValue("teamId", user.teamId)
            setValue("handlerId", user.userId)
        }
    }, [user]);

    return <div className={pageType === "company" ? "fiter_wrap" : "fiter_wrap mb-0"}>
        <div className="fiter_top">
            <h3 className="filter_heading">매출 조회</h3>
            <div className="filter_toolbar">
                {tab === 2 &&
                    <>
                        {!isModify ? <AuthorityChecker authorityNames={['salesWriteYn']}>
                                <button className="btn btn-secondary w-100px h-38px"
                                        onClick={() => toggleIsModify && toggleIsModify()}
                                        disabled={searchParam.handlerId != user?.userId}>수정
                                </button>
                            </AuthorityChecker>
                            : <>
                                <button className="btn btn-primary w-100px h-38px"
                                        onClick={() => btnModifySave && btnModifySave()}>
                                    저장
                                </button>
                                <button className="btn btn-outline-secondary w-100px h-38px"
                                        onClick={() => toggleIsModify && toggleIsModify()}>
                                    취소
                                </button>
                            </>
                        }
                    </>
                }
            </div>
        </div>
        <form className="row" onSubmit={handleSubmit(onSubmit)}>
            <div className="col-6">
                <div className="frm_row search justify-content-start">
                    <label htmlFor="" className="form-label frm_label">날짜</label>
                    <select className="form-select"
                            value={watch("revenueYear")}
                            {...register("revenueYear")}>
                        {yearOptions}
                    </select>
                    {pageType !== "company" && <select className="form-select me-0"
                                                       value={watch("revenueMonth")}
                                                       {...register("revenueMonth")}
                                                       disabled={tab === 1}>
                        {monthOptions}
                    </select>}
                    <button className="btn btn-info btn_search" disabled={isModify}>
                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt=""/>조회
                    </button>
                </div>
            </div>
            {pageType !== "company" && <div className="col-6">
                <div className="frm_row search justify-content-start">
                    <label htmlFor="" className="form-label frm_label">팀/담당자</label>
                    <select className="form-select w-150px"
                            value={watch("teamId") ?? undefined}
                            {...register("teamId")}>
                        <option value={""}>전체</option>
                        {teamList?.map((el: any) => <option value={el.teamId}>{el.name}</option>)}
                    </select>
                    <select className="form-select w-140px me-0"
                            value={watch("handlerId")}
                            {...register("handlerId")}>
                        <option value={0}>전체</option>
                        {handlerList?.map((el: any) => <option value={el.userId}>{el.userName}</option>)}
                    </select>
                    <button className="btn btn-info btn_search" disabled={isModify}>
                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt=""/>조회
                    </button>
                </div>
            </div>}
        </form>
    </div>
}